import { configureStore } from "@reduxjs/toolkit";
import { createReduxHistoryContext } from "redux-first-history";
import { createBrowserHistory } from "history";

import app from "./slices/app";
import authPages from "./slices/authPages";
import reportsPage from "./slices/reportsPage";
import onboardingPage from "./slices/onboardingPage";
import overviewMonitoringPage from "./slices/overview/monitoringPage";
import overviewOnboardingPage from "./slices/overview/onboardingPage";
import overviewPortfolioPage from "./slices/overview/portfolioPage";
import monitoringPage from "./slices/monitoringPage";
import portfolioPage from "./slices/portfolioPage";
import administrationPage from "./slices/administrationPage";
import approvalPage from "./slices/approvalPage";
import SystemSettingsPage from "./slices/SystemSettingsPage";
import contractTermsPage from "./slices/contractTermsPage";

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory()
});

const middlewares = [routerMiddleware];

const store = configureStore({
  reducer: {
    router: routerReducer,
    app,
    authPages,
    overviewMonitoringPage,
    overviewOnboardingPage,
    overviewPortfolioPage,
    onboardingPage,
    portfolioPage,
    monitoringPage,
    reportsPage,
    administrationPage,
    approvalPage,
    SystemSettingsPage,
    contractTermsPage
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middlewares)
});

export const history = createReduxHistory(store);

export default store;
